import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import PublicQuoteForm from '../components/public/PublicQuoteForm';

// ============================================================================
// EMBED QUOTE PAGE - For iframe embedding on external websites
// URL: /embed/quote/:slug
// 
// Usage on external site:
// <iframe 
//   src="https://app.suddyflow.com/embed/quote/joes-pressure-washing"
//   width="100%" 
//   height="800" 
//   frameborder="0"
// ></iframe>
// ============================================================================

const EmbedQuotePage = () => {
  const { slug } = useParams();
  const [searchParams] = useSearchParams();
  
  // Optional: Allow parent to specify a redirect URL on success
  const redirectUrl = searchParams.get('redirect');
  
  const handleSuccess = (data) => {
    // Post message to parent window (for iframe communication)
    if (window.parent !== window) {
      window.parent.postMessage({
        type: 'SUDDYFLOW_LEAD_SUBMITTED',
        data: {
          leadId: data.leadId,
          quoteRange: data.quoteRange,
          isReturningCustomer: data.isReturningCustomer
        }
      }, '*');
    }
    
    // Redirect if URL provided
    if (redirectUrl) {
      window.top.location.href = redirectUrl;
    }
  };

  return (
    <div className="min-h-screen">
      <PublicQuoteForm 
        slug={slug} 
        onSuccess={handleSuccess}
      />
    </div>
  );
};

export default EmbedQuotePage;